export function trimText(input: string): string {
  if (input.length > 80) {
    return `${input.substr(0, 0)}  ... ${input.substr(input.length - 15, input.length)}`;
  }

  return input;
}
